import { invariant } from 'folio-common-utils';

export function getReactRoot() {
  const ele = document.querySelector<HTMLElement>('#root');
  invariant(ele, 'Unable to find root element');
  return ele;
}
